import { Accordion, Span } from "@chakra-ui/react";
import { ChevronRight } from "lucide-react";

export default function DynamicAccordion({ data }) {
    return (
        <Accordion.Root collapsible mt={'var(--space-2xs)'}>
            {data.map((item, index) => (
                <Accordion.Item key={index} value={item.value}>
                <Accordion.ItemTrigger>
                    <Accordion.ItemIndicator _open={{ transform: "rotate(-90deg)" }}>
                        <ChevronRight />
                    </Accordion.ItemIndicator>
                    <Span flex="1" fontWeight={'bold'}>{item.question}</Span>
                </Accordion.ItemTrigger>
                <Accordion.ItemContent pl={8}>
                    <Accordion.ItemBody className="flow" style={{ '--flow-space': 'var(--space-s)' }}>{item.answer}</Accordion.ItemBody>
                </Accordion.ItemContent>
                </Accordion.Item>
            ))}
        </Accordion.Root>
    );
}